import enrollment from '@/api/student-enrollment'
import operationClass from '@/api/class-operation'
import student from '@/api/student-profile'
import subProgram from '@/api/sub-program'
import level from '@/api/level'

import { baseState, baseMutations } from '@/store/mixins'
import { join } from 'lodash'

export const state = {
  ...baseState,
  edit_data: {},
  classOperations: [],
  student_status_id: [],
  status: [1],
  ac_status_id: [],
  ac_year_id: []
}

export const getters = {
  studentFilter:
    state =>
      ({ student_id, studentEnrollments } = {}) => {
        return studentEnrollments.find(s => s.student_id == student_id)
      }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_STATUS_VALUE(state, value) {
    state.status = value
  },
  SET_ACADEMIC_YEAR_VALUE(state, value) {
    state.ac_year_id = value
  },
  SET_STUDENT_STATUS_VALUE(state, value) {
    state.student_status_id = value.length > 0 ? value : [1]
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        student_status_id: context.state.student_status_id,
        ac_year: context.state.ac_year_id,
        filter: {
          ac_status_id: join(context.state.status, ',')
        }
      },
      attrubutes
    )
    return enrollment.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return enrollment.store(data)
  },

  update(context, data) {
    return enrollment.update(data)
  },
  destroy(context, id) {
    return enrollment.destroy(id)
  },
  storeStudentForward(context, data) {
    return enrollment.forwardClass(data)
  },

  async getClassOperation(context, attrubutes = {}) {
    let params = Object.assign(
      {
        include: 'term,teacher,academicStatus,academicStudyTimes,weekdayType,room',
        filter: {
          ac_status_id: '1,3,2'
        },
        fields: {
          academic_classes:
            'class_id,class_name,ac_term_id,teacher_id,acps_id,acp_id,ac_status_id,academic_year,academic_term,ac_st_id,room_id,weekday_type_id,intake',
          academic_study_times: 'ac_st_id,study_time,session,number_of_session',
          weekday_type: 'id,weekday_type'
        }
      },
      attrubutes
    )
    return await operationClass.get({ params })
  },
  async getStudent(context, attrubutes = {}) {
    let params = Object.assign(
      {
        include: 'sub_program,level,study_time',
        fields: {
          setup_student_profiles:
            'student_id,card_number,first_name_en,last_name_en,gender,phone,date_of_birth,acps_id,promotion,level_id,ac_st_id',
          sub_program: 'acps_id,acps_name_foreign',
          level: 'level_id,level_name_foreign',
          study_time: 'ac_st_id,study_time,session'

        }
      },
      attrubutes
    )
    return await student.get({ params })
  },
  fetchStudentEnrollByClass(context, attrubutes = {}) {
    return enrollment.get({ params: attrubutes })
  },
  fetchSubProgram(context, attributes = {}) {
    return subProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getLevel(context, attributes = {}) {
    return level.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_levels:
            'acps_id,level_id,level_name_foreign,level_name_native'
        },
        ...attributes
      }
    })
  },
}
